var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarChartLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5210_347858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 4H8V20H6V4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4H18V20H16V4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6L6 8L2 8L2 6L6 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15L12 17L8 17L8 15L12 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 4L22 6L18 6L18 4L22 4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10L16 12L12 12L12 10L16 10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5210_347858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartLight);
export default __webpack_public_path__ + "static/media/bar-chart_light.351de58f.svg";
export { ForwardRef as ReactComponent };